import * as Types from './types';
import { Dispatch } from 'redux';
import {
  IAction,
  IActionMethods,
  KEEP_THE_SAME,
  StateStatus,
} from '../../../redux/utils/common';
import * as PaymentListService from '../../../services/api/payment_list';
import ModalActions from 'redux/reducers/gl_modal_reducer/actions';
import { ModalIDs } from '../gl_modal_reducer/types';
import { getState } from 'redux/store';
import { ReducerKeys } from 'redux/reducers';

/** Fetch FetchAPPLICANT_PAYMENTListInput  */

interface SetPaymentInput {
  sortField: string;
  page: number;
  pageSize: number;
  order: 'asc' | 'desc';
  vat_num?: string;
  schemeType?: string;
}

class SetPayments implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_PAYMENT_LIST,
      status: StateStatus.Pending,
      data: KEEP_THE_SAME,
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_PAYMENT_LIST,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_PAYMENT_LIST,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(payload: SetPaymentInput): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await PaymentListService.fetchPaymentList(payload);
        dispatch(this.onSuccess(response.data));
      } catch (error: any) {
        // console.log('SetPayments Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

interface IPaymentInfo {
  onFinish?: (success: boolean) => void;
}
class PaymentInfo implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.PAYMENT_INFO,
      status: StateStatus.Pending,
      data: null,
    };
  }
  onSuccess(): IAction {
    return {
      type: Types.PAYMENT_INFO,
      status: StateStatus.Success,
      data: null,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.PAYMENT_INFO,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(payload: IPaymentInfo): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        await PaymentListService.paymentInfo();
        dispatch(this.onSuccess());
        payload.onFinish && payload.onFinish(true);
      } catch (error: any) {
        // console.log('PaymentInfo Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

interface SetPaymentInfoInput {
  sortField: string;
  page: number;
  pageSize: number;
  order: 'asc' | 'desc';
  paymentRef?: string;
  schemeType?: string;
  msconCountry?: string;
}

class SetPaymentInfoList implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_PAYMENT_INFO_LIST,
      status: StateStatus.Pending,
      data: KEEP_THE_SAME,
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_PAYMENT_INFO_LIST,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_PAYMENT_INFO_LIST,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(payload: SetPaymentInfoInput): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await PaymentListService.fetchPaymentInfoList(payload);
        dispatch(this.onSuccess(response.data));
      } catch (error: any) {
        // console.log('SetPaymentInfoList Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

interface IUpdatePaymentInfoReferenceInput {
  // payment_reference: string;
  payment_date: Date;
  payment_info_id: number;
}
class UpdatePaymentInfoReference implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.UPDATE_PAYMENT_INFO_REFERENCE,
      status: StateStatus.Pending,
      data: null,
    };
  }
  onSuccess(): IAction {
    return {
      type: Types.UPDATE_PAYMENT_INFO_REFERENCE,
      status: StateStatus.Success,
      data: null,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.UPDATE_PAYMENT_INFO_REFERENCE,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(payload: IUpdatePaymentInfoReferenceInput): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        await PaymentListService.updatePaymentInfoReference(payload);
        const state = getState(ReducerKeys.PAYMENT_LIST_REDUCER).paymentInfoList
          .data;
        const paging = state.paging;
        const sorting = state.sorting;
        dispatch(
          new SetPaymentInfoList().action({
            sortField: sorting.sortField,
            page: paging.page,
            pageSize: paging.pageSize,
            order: sorting.order,
          })
        );
        dispatch(
          ModalActions.closeModalAction({
            modalID: ModalIDs.MODAL_UPDATE_PAYMENT_INFO_REFERENCE,
          })
        );
        dispatch(this.onSuccess());
      } catch (error: any) {
        // console.log('UpdatePaymentInfoReference Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

export default {
  setPaymentsAction: (payload: SetPaymentInput) =>
    new SetPayments().action(payload),
  paymentInfoAction: (payload: IPaymentInfo) =>
    new PaymentInfo().action(payload),
  fetchPaymentInfoAction: (payload: SetPaymentInfoInput) =>
    new SetPaymentInfoList().action(payload),
  updatePaymentInfoReferenceAction: (
    payload: IUpdatePaymentInfoReferenceInput
  ) => new UpdatePaymentInfoReference().action(payload),
};
